module.exports = __webpack_public_path__ + "img/navIcons.f3647a8d.png";